var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclePauseRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 7.5C8.75625 7.5 8.25 8.00625 8.25 8.625V15.375C8.25 15.9984 8.75625 16.5 9.375 16.5C9.99375 16.5 10.5 15.9984 10.5 15.375V8.625C10.5 8.00625 9.99844 7.5 9.375 7.5ZM14.625 7.5C14.0063 7.5 13.5 8.00625 13.5 8.625V15.375C13.5 15.9961 14.0039 16.5 14.625 16.5C15.2461 16.5 15.75 15.9961 15.75 15.375V8.625C15.75 8.00625 15.2484 7.5 14.625 7.5ZM12 0C5.37188 0 0 5.37188 0 12C0 18.6281 5.37188 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0ZM12 21.75C6.62344 21.75 2.25 17.3761 2.25 12C2.25 6.62391 6.62344 2.25 12 2.25C17.3766 2.25 21.75 6.62391 21.75 12C21.75 17.3761 17.3766 21.75 12 21.75Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePauseRegular);
export default __webpack_public_path__ + "static/media/circle-pause-regular.440e18de17402709c59ad06241de8e56.svg";
export { ForwardRef as ReactComponent };